import React, { Component } from 'react'
import './Obhodnoilist.css'
import ReactToPrint, { PrintContextConsumer } from 'react-to-print';
import './SocFond.css'

export default class SocFond extends Component {
    constructor(props) {
        super(props)
        var today = new Date(),
            date = today.getDate() + '.' + (today.getMonth().length < 8 ? '0' : '') + (today.getMonth() + 1) + '.' + today.getFullYear();
        // datetime = (today.getDate() + '.' + (today.getMonth() + 1) + '.' + today.getFullYear() + ' ' + today.getHours() + ':' + today.getMinutes() + ':' + today.getSeconds())
        this.state = {
            // currentDateTime: datetime,
            text_gorod_obl: null,
            paste: false,
            currentDate: date,
            input_active: 0
        }
    }

    OpenReportsPage(reportsPage, reportType, id_student, id_group, id_faculty, id_raion, id_protocols, id_okno_zakaz) {
        this.props.OpenReportsPage(reportsPage, reportType, id_student, id_group, id_faculty, id_raion, id_protocols, id_okno_zakaz)
    }
    selectLanguage(language) {
        this.props.selectLanguage(language)
    }
    onChange = (e) => {
        this.setState({ text_gorod_obl: e.target.value, input_active: 1 })
        if (this.state.text_gorod_obl !== null) {
            this.setState({ input_active: 0 })
        }
    }
    pasteText = () => {
        this.setState(prevState => ({
            paste: !prevState.paste
        }));
        this.setState({
            input_active: 0
        })
    }

    render() {
        const { VoenKom, photo, id_student, id_group, id_faculty, id_raion, id_protocols, id_okno_zakaz, Republics, id_republics } = this.props
        const { text_gorod_obl, paste, input_active } = this.state
        // console.log("VoenKom", VoenKom)
        return (
            <div className='ObhodnoiList D_main_header' >
                <header>
                    <i className="fas fa-arrow-left" onClick={() => this.OpenReportsPage(0, 0, id_student, id_group, id_faculty, id_raion, id_protocols, id_okno_zakaz)}></i>
                    <ReactToPrint content={() => this.componentRef}>
                        <PrintContextConsumer>
                            {({ handlePrint }) => (
                                <i onClick={handlePrint} className="fa fa-print" title="Печать"></i>
                            )}

                        </PrintContextConsumer>
                    </ReactToPrint>
                    {this.props.language === 1 ? <h2>Соцфонд</h2> : <h2>Соцфонд</h2>}
                    {/* <div className='Language'>
                        <h4 onClick={() => this.selectLanguage(1)} className={this.props.language === 1 ? 'Lang_Active' : 'Lang'}>Рус</h4>
                        <h4 onClick={() => this.selectLanguage(2)} className={this.props.language === 2 ? 'Lang_Active' : 'Lang'}>Кырг</h4>
                    </div> */}
                    <div className='SpravkaObOkonch_input Socfond_header_input'>
                        <p>Добавить город или область</p>
                        <input type='text' onChange={this.onChange}>
                        </input>
                        {
                            <button onClick={() => this.pasteText()}>
                                <h5>{paste === true && text_gorod_obl && text_gorod_obl !== ' ' ? 'Убрать' : 'Вставить'}</h5>
                            </button>
                        }
                    </div>
                </header>

                <div className="A4 SocFond" ref={el => (this.componentRef = el)}>
                    <div className='SocFond_header'>
                        <div style={{ display: 'block' }}>
                            <p>{"Дата выдачи " + this.state.currentDate}</p>
                            <p> Исх. №__________ </p>
                        </div>
                        <div className='SocFond_header_Ava_person'>
                            {photo && photo.length > 0 ? <img src={`data:image/jpeg;base64,${photo}`} alt='Avatar' /> :
                                <span>Photo</span>
                            }
                        </div>
                    </div>
                    <div className='SocFond_body'>
                        <h3>Справка</h3>
                        <table>
                            <tr>
                                <td>
                                    {`Дана ${VoenKom && VoenKom.length && VoenKom[1][0].Male === true ? 'гражданину' : 'гражданке'}  ${VoenKom && VoenKom.length && VoenKom[1][0].s_fio} дата рождения  ${VoenKom && VoenKom.length && VoenKom[1][0].BirthDate} года`}
                                </td>
                            </tr>
                            <tr>
                                <td>
                                    {`в том что ${VoenKom && VoenKom.length && VoenKom[1][0].Male === true ? 'он' : 'она'} действительно является ${VoenKom && VoenKom.length && VoenKom[1][0].Male === true ? 'студентом' : 'студенткой'} 
                                    ${VoenKom && VoenKom.length && VoenKom[0][0].v4}, ${VoenKom && VoenKom.length && VoenKom[1][0].id_rate}-курса, факультета ${VoenKom && VoenKom.length && VoenKom[0][0].faculty}.`}
                                </td>
                            </tr>
                            <tr>
                                <td>
                                    {`Форма обучения:  ${VoenKom && VoenKom.length && VoenKom[1][0].p108},`}  <span style={{ textTransform: 'lowercase' }}>{VoenKom && VoenKom.length && VoenKom[1][0].name}</span>
                                </td>
                            </tr>
                            <tr>
                                <td>
                                    {`Справка действительна на 20${this.props.DefYear}-${this.props.DefYear + 1} учебный год`}
                                </td>
                            </tr>
                            <tr>
                                <td>
                                    {`Справка выдана для предъявления в ${VoenKom && VoenKom.length && VoenKom[3][0].raion} район`}{input_active === 1 || (paste === true && text_gorod_obl && text_gorod_obl.length) ? ',' : null} {input_active === 1 && !text_gorod_obl ? '_____________________________________' : paste == true ? text_gorod_obl : null}
                                </td>
                            </tr>
                            <tr>
                                <td>
                                    {`Управление Социального фонда ${Republics && Republics.length && Republics.filter(item => item.id_republics == id_republics)[0].republic_okno} .`}
                                </td>
                            </tr>
                            <tr>
                                <td>
                                    <br />
                                    {`Срок обучения в учебном заведении ${VoenKom && VoenKom.length && VoenKom[2][0].max_rate_id} года.`}
                                </td>
                            </tr>
                            <tr>
                                <td>
                                    {`Период обучения с ${this.props.startYear} по ${this.props.endYear} гг.`}
                                </td>
                            </tr>
                        </table>
                    </div>
                    <div className="SocFond_Footer">
                        <h3>Примечание:</h3>
                        <p>Лицо, выдавшее настоящую справку, несет персональную ответственность за достоверность указанных в ней сведений.</p>
                        <table>
                            <tbody>
                                <tr>
                                    <td colSpan='2' style={{ width: '80%' }}>
                                        {VoenKom && VoenKom.length && VoenKom[7][0].insert_pole}
                                    </td>
                                    <td></td>
                                </tr>
                                <tr>
                                    <td colSpan='2'>
                                    </td>
                                    <td>(подпись)</td>
                                </tr>
                            </tbody>
                        </table>
                        <h5>Исполнитель: </h5>
                        <h5>{this.props.user_fio}, {this.props.doljnost}</h5>

                    </div>
                </div>

            </div>
        )
    }
}


